/* eslint-disable sonarjs/cognitive-complexity */
import React, { useState, useRef, useEffect, useCallback, useMemo, } from 'react';
import { mapToCssModules } from '../../utils/className';
export const SmlsDropzone = ({ id, disabled = false, cbOnFilesAdded, collapsed = false, acceptAllMIMETypes = false, textDesktop, textMobile, textDesktopDrop, extensions = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'], textExtensions = '(.jpg, .jpeg, .png ou .pdf)', className = '', }) => {
    const [highlight, setHighlight] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);
    const fileInputRef = useRef(null);
    const MimeTypes = useMemo(() => {
        if (acceptAllMIMETypes)
            return '';
        return extensions.join(', ');
    }, [extensions, acceptAllMIMETypes]);
    const verifyIfIsDesktop = useCallback((width, height) => {
        if (width < 600 || height < 600)
            setIsDesktop(false);
        else
            setIsDesktop(true);
    }, []);
    // TO DO : resize listener in custom hooks
    useEffect(() => {
        verifyIfIsDesktop(window.innerWidth, window.innerHeight);
        window.addEventListener('resize', () => {
            verifyIfIsDesktop(window.innerWidth, window.innerHeight);
        });
    }, [verifyIfIsDesktop]);
    function fileListToArray(list) {
        const array = [];
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < list.length; i++) {
            array.push(list.item(i));
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        if (acceptAllMIMETypes)
            return array;
        const arrayFiltered = array.filter((file) => extensions.some((el) => el === (file === null || file === void 0 ? void 0 : file.type)));
        return arrayFiltered;
    }
    function openFileDialog() {
        if (disabled)
            return;
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }
    function onFilesAdded(event) {
        if (disabled)
            return;
        const files = event.target.files;
        if (cbOnFilesAdded) {
            const array = fileListToArray(files);
            cbOnFilesAdded(array);
        }
    }
    function onDragOver(event) {
        event.preventDefault();
        if (disabled)
            return;
        setHighlight(true);
    }
    function onDragLeave() {
        setHighlight(false);
    }
    function onDrop(event) {
        event.preventDefault();
        if (disabled)
            return;
        const files = event.dataTransfer.files;
        if (cbOnFilesAdded) {
            const array = fileListToArray(files);
            cbOnFilesAdded(array);
        }
        setHighlight(false);
    }
    return (React.createElement("div", { id: id, className: mapToCssModules([
            'smls-dropzone',
            highlight ? 'highlight' : '',
            isDesktop && !collapsed ? 'full' : '',
            disabled ? 'disabled' : '',
            className,
        ]), onDragOver: onDragOver, onDragLeave: onDragLeave, onDrop: onDrop, onClick: openFileDialog, style: { cursor: disabled ? 'default' : 'pointer' } },
        React.createElement("input", { ref: fileInputRef, disabled: disabled, className: "file-input", type: "file", accept: MimeTypes, multiple: true, onChange: onFilesAdded }),
        !highlight && React.createElement("i", { className: "material-icons" }, "attach_file"),
        React.createElement("div", { className: "text-default" }, highlight ? (React.createElement("span", null, textDesktopDrop)) : (React.createElement(React.Fragment, null,
            React.createElement("span", null, isDesktop ? textDesktop : textMobile),
            React.createElement("span", null, textExtensions))))));
};
//# sourceMappingURL=index.js.map